import { render, staticRenderFns } from "./teachers-form.vue?vue&type=template&id=40159558&lang=pug&"
import script from "./teachers-form.vue?vue&type=script&lang=js&"
export * from "./teachers-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports